<template lang="html">
    <div class="home-view">
        <!-- margin-top comes from the height of `title-icons` + the margin of `entity-container` -->
        <global-view style="margin-top: 48.45px;margin-right: 40px;"></global-view>
        <entities-selector v-if="currentEntity === null" class="right-part"></entities-selector>
        <div v-else-if="!modelsScopedLoaded" class="loading-models">
            <div class="text-center right-part">
                <div>LOADING MODELS</div>
                <loading-template></loading-template>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalView from './global-view.vue';
import EntitiesSelector from './entities-selector.vue';
import { LoadingTemplate } from 'gcmcn-common';
import { mapGetters } from 'vuex';
export default {
    components: {
        GlobalView,
        EntitiesSelector,
        LoadingTemplate,
    },
    data () {
        return {

        };
    },
    computed: {
        ...mapGetters([
            'currentEntity',
            'currentTaker',
            'modelsScopedLoaded',
        ]),
    },

    watch: {
        modelsScopedLoaded:{
            handler (val){
                // si val alors entité sélectionné
                if(val && this.currentTaker){
                    this.$store.dispatch('fetchTakerCurrentGroup').then(() => this.$router.push('/feed'));
                }else if(val){
                    this.$router.push('/select-taker');
                }
            },
            deep: true,
        },
    },
    mounted (){
        this.reset();
    },

    methods: {
        reset (){
            this.$store.dispatch('cancelFetchModelsPeriodically');
            this.$store.commit('SET_CURRENT_ENTITY', null);
            this.$store.commit('RESET_MODELS_SCOPED', this.$store.getters.scopedModels);
            this.$store.commit('REMOVE_CURRENT_TAKER');

        }
    }
};
</script>

<style lang="scss">
    .home-view{
        margin-left: 140px;
        display: flex;

        .right-part{
            width: 680px;
        }
    }
    @media screen and (max-width: 1024px) {
        .home-view{
            margin-left: 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/Home/index.vue